<template>
  <div class="info-box">
    <div
      class="flex-1 grid gap-x-5 overflow-hidden"
      style="grid-template-columns: 15% 1fr"
    >
      <div class="flex flex-col overflow-hidden">
        <ul class="text-xs text-orange-500">
          注：左侧填写的信息将会在添加采购项时自动带入，也可自行在采购项中独立修改
        </ul>
        <el-form
          :model="state.model"
          label-width="auto"
          label-position="top"
          ref="formDom"
          class="overflow-y-auto pr-3"
          style="--el-form-label-font-size: 12px"
        >
          <el-form-item label="所属分会">
            <template #label>
              <text>所属分会</text>
              <text class="text-orange-400 text-xs"> </text>
            </template>
            <el-select v-model="state.model.hc_id" filterable>
              <template #label="{ value }">
                <div
                  v-if="hc_map.get(value)"
                  class="flex gap-x-5 !w-full"
                >
                  <text>{{ hc_map.get(value).name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ hc_map.get(value).hotel?.name + "-" + hc_map.get(value).hotelHall?.name }}
                  </div>
                </div>
              </template>
              <el-option
                v-for="item in state.hc_data"
                :key="item.id"
                :label="`${item.name} ${item.hotel?.name} ${item.hotelHall?.name} ${item.hotel?.address}`"
                :value="item.id"
              >
                <div class="flex gap-x-5 !w-full">
                  <text>{{ item.name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    <text>{{
                      item.hotel?.name + "-" + item.hotelHall?.name
                    }}</text>
                    <text>{{ item.hotel?.address }}</text>
                  </div>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadHc"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商">
            <el-select v-model="state.model.gys_id" filterable>
              <template #label="{ value }">
                <div
                  v-if="gys_map.get(value)"
                  class="flex gap-x-5 !w-full"
                >
                  <text>{{ gys_map.get(value).name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ gys_map.get(value).number }}
                  </div>
                </div>
              </template>
              <el-option
                v-for="item in state.gys_data"
                :key="item.id"
                :label="`${item.name} ${item.number}`"
                :value="item.id"
              >
                <div class="flex gap-x-5 !w-full">
                  <text>{{ item.name }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ item.number }}
                  </div>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadGys"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="采购名称">
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="state.model.remark"></el-input>
          </el-form-item>
          <el-form-item label="物料类型">
            <el-select v-model="state.model.lx_id">
              <el-option
                v-for="item in state.lx_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadLx"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model="state.model.mc"></el-input>
          </el-form-item>
          <el-form-item label="物料规格">
            <el-input v-model="state.model.gg"></el-input>
          </el-form-item>
          <el-form-item label="物料单位">
            <el-select v-model="state.model.dw">
              <el-option
                v-for="item in state.type_data"
                :key="item"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadDw"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="采购单价">
            <el-input-number
              v-model="state.model.dj"
              :min="0"
              precision="2"
              class="!w-full"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="采购数量">
            <el-input-number
              v-model="state.model.num"
              :min="0"
              controls
              class="!w-full"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="使用天数">
            <el-input-number
              v-model="state.model.days"
              :min="0"
              controls
              class="!w-full"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="flex flex-col overflow-hidden">
        <ul class="flex mt-2">
          <li class="flex-1 font-bold text-sm">采购明细</li>
          <el-button
            icon="RefreshLeft"
            size="small"
            link
            style="top: 48px"
            type="danger"
            @click="state.model = {}"
          >
            重置表单
          </el-button>
          <el-button type="primary" link icon="Plus" @click="onAdd(1)">
            添加明细
          </el-button>
          <el-button type="primary" link icon="DocumentAdd" @click="onAdd(2)">
            插入空白行
          </el-button>
          <el-button type="success" link icon="Download">导入常用项</el-button>
          <el-button type="warning" link icon="Download">物料库导入</el-button>
          <el-button type="warning" link icon="Sort" @click="onChangeTab">
            批量覆盖列表
            <el-tooltip
              placement="top"
              effect="dark"
              content="此按钮会将上方表单中已填写/选择的内容批量替换到表格中已勾选行对应的字段，未填写/选择的内容将不会替换"
            >
              <el-icon class="cursor-pointer"><QuestionFilled /></el-icon>
            </el-tooltip>
          </el-button>
        </ul>
        <div class="flex-1 flex flex-col overflow-hidden mt-2">
          <el-table
            ref="tabDom"
            :data="state.list_data"
            v-loading="!Array.isArray(state.list_data)"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            max-height="65vh"
            :show-overflow-tooltip="false"
          >
            <el-table-column type="selection" :width="60" fixed />
            <el-table-column type="index" label="序号" :width="60" fixed />
            <el-table-column>
              <template #header>
                <div
                  class="c-table-col-header"
                  label1="所属分会"
                  label2="供应商"
                />
              </template>
              <template #default="{ row }">
                <c_tabgroup>
                  <template #top>
                    <el-select v-model="row.hc_id" placeholder="所属分会">
                      <template #label="{ label, value }">
                        <div class="flex gap-x-5 !w-full">
                          <text>{{ label.name }}</text>
                          <div
                            class="flex flex-col items-end flex-1 text-gray-400"
                            style="font-size: 12px"
                          >
                            {{
                              label.hotel?.name + "-" + label.hotelHall?.name
                            }}
                          </div>
                        </div>
                      </template>
                      <el-option
                        v-for="item in state.hc_data"
                        :key="item"
                        :label="item"
                        :value="item.id"
                      >
                        <div class="flex gap-x-5 !w-full">
                          <text>{{ item.name }}</text>
                          <div
                            class="flex flex-col items-end flex-1 text-gray-400"
                            style="font-size: 12px"
                          >
                            <text>{{
                              item.hotel?.name + "-" + item.hotelHall?.name
                            }}</text>
                            <text>{{ item.hotel?.address }}</text>
                          </div>
                        </div>
                      </el-option>
                      <template #footer>
                        <el-button
                          plain
                          class="float-right mb-3"
                          size="small"
                          @click="onLoadHc"
                        >
                          刷新
                        </el-button>
                      </template>
                    </el-select>
                  </template>
                  <template #bottom>
                    <el-select
                      v-model="row.gys_id"
                      placeholder="供应商"
                      class="mt-1"
                    >
                      <template #label="{ label, value }">
                        <div class="flex gap-x-5 !w-full">
                          <text>{{ label.name }}</text>
                          <div
                            class="flex flex-col items-end flex-1 text-gray-400"
                            style="font-size: 12px"
                          >
                            {{ label.number }}
                          </div>
                        </div>
                      </template>
                      <el-option
                        v-for="item in state.gys_data"
                        :key="item"
                        :label="item"
                        :value="item.id"
                      >
                        <div class="flex gap-x-5 !w-full">
                          <text>{{ item.name }}</text>
                          <div
                            class="flex flex-col items-end flex-1 text-gray-400"
                            style="font-size: 12px"
                          >
                            {{ item.number }}
                          </div>
                        </div>
                      </el-option>
                      <template #footer>
                        <el-button
                          plain
                          class="float-right mb-3"
                          size="small"
                          @click="onLoadGys"
                        >
                          刷新
                        </el-button>
                      </template>
                    </el-select>
                  </template>
                </c_tabgroup>
              </template>
            </el-table-column>
            <el-table-column>
              <template #header>
                <div
                  class="c-table-col-header"
                  label1="采购名称"
                  label2="备注"
                />
              </template>
              <template #default="{ row }">
                <c_tabgroup>
                  <template #top>
                    <el-input v-model="row.name" placeholder="采购名称" />
                  </template>
                  <template #bottom>
                    <el-input
                      v-model="row.remark"
                      placeholder="备注"
                      class="mt-1"
                    />
                  </template>
                </c_tabgroup>
              </template>
            </el-table-column>
            <el-table-column>
              <template #header>
                <div
                  class="c-table-col-header"
                  label1="物料类型"
                  label2="物料名称"
                />
              </template>
              <template #default="{ row }">
                <c_tabgroup>
                  <template #top>
                    <el-select
                      v-model="row.lx_id"
                      placeholder="物料类型"
                      class="mt-1"
                    >
                      <el-option
                        v-for="item in state.type_data"
                        :key="item"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                      <template #footer>
                        <el-button
                          plain
                          class="float-right mb-3"
                          size="small"
                          @click="onLoadType"
                        >
                          刷新
                        </el-button>
                      </template>
                    </el-select>
                  </template>
                  <template #bottom>
                    <el-input
                      v-model="row.mc"
                      class="mt-1"
                      placeholder="物料名称"
                    />
                  </template>
                </c_tabgroup>
              </template>
            </el-table-column>
            <el-table-column>
              <template #header>
                <div
                  class="c-table-col-header"
                  label1="物料规格"
                  label2="物料单位"
                />
              </template>
              <template #default="{ row }">
                <c_tabgroup>
                  <template #top>
                    <el-input
                      v-model="row.gg"
                      class="mt-1"
                      placeholder="物料规格"
                    />
                  </template>
                  <template #bottom>
                    <el-select
                      v-model="row.dw"
                      placeholder="物料单位"
                      class="mt-1"
                    >
                      <el-option
                        v-for="item in state.type_data"
                        :key="item"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                      <template #footer>
                        <el-button
                          plain
                          class="float-right mb-3"
                          size="small"
                          @click="onLoadType"
                        >
                          刷新
                        </el-button>
                      </template>
                    </el-select>
                  </template>
                </c_tabgroup>
              </template>
            </el-table-column>
            <el-table-column label="采购单价" align="center" :width="120">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.dj"
                  class="!w-full"
                  precision="2"
                  placeholder="采购单价"
                  @focus="$onFocus"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" :width="200">
              <template #header>
                <div class="flex items-center gap-x-1 justify-center">
                  <div
                    class="c-table-col-header"
                    label1="数量"
                    label2="天数"
                  ></div>
                  <el-tooltip
                    placement="top"
                    effect="dark"
                    content="天数=租赁设备的使用天数"
                  >
                    <el-icon class="cursor-pointer"><QuestionFilled /></el-icon>
                  </el-tooltip>
                </div>
              </template>
              <template #default="{ row }">
                <div class="grid grid-cols-2 gap-x-1">
                  <el-input-number
                    v-model="row.num"
                    class="!w-full"
                    placeholder="数量"
                    @focus="$onFocus"
                  />
                  <el-input-number
                    v-model="row.days"
                    precision="0"
                    class="!w-full"
                    placeholder="天数"
                    @focus="$onFocus"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="合计"
              prop="hj"
              :formatter="$tab_MoneyFormat"
              align="right"
              :width="80"
            />
            <el-table-column
              label="操作"
              :width="80"
              fixed="right"
              align="center"
            >
              <template #default="{ row }">
                <el-button type="danger" link icon="Delete"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="warning" size="large" @click="onSubmit">
        暂存
      </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import { data_getMeetingPlace, data_getSupplier } from "@/http/data";
import {
  meeting_place_detail,
  meeting_place_add,
  meeting_place_edit,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const tabDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: {
        num: 1,
        days: 1,
      },
    });
    onMounted(() => {
      onLoad();
      onLoadHc();
      onLoadGys();
    });

    const onLoad = () => {
      delete state.list_data;

      state.list_data = [];
    };

    //加载会场
    const onLoadHc = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.hc_data = res.data?.data?.list || [];
      });
    };

    //会场 id 索引，O(1) 查找
    const hc_map = computed(() => {
      const m = new Map();
      state.hc_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onLoadGys = () => {
      data_getSupplier().then((res) => {
        state.gys_data = res.data?.data?.list || [];
      });
    };

    //供应商 id 索引，O(1) 查找
    const gys_map = computed(() => {
      const m = new Map();
      state.gys_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onAdd = (type) => {
      let item = {};
      if (type === 1) {
        item = {
          hc_id: state.model.hc_id,
          gys_id: state.model.gys_id,
          name: state.model.name,
          remark: state.model.remark,
          days: state.model.days,
        };
      }
      state.list_data.push(item);
      if (!tabDom.value) return;
      setTimeout(() => {
        tabDom.value.setScrollTop(1000000);
      }, 200);
    };

    const onChangeTab = () => {
      let rows = tabDom.value.getSelectionRows();
      rows.forEach((row) => {
        if (state.model.hc_id) row.hc_id = state.model.hc_id;
        if (state.model.gys_id) row.gys_id = state.model.gys_id;
        if (state.model.name) row.name = state.model.name;
        if (state.model.remark) row.remark = state.model.remark;
        if (state.model.days) row.days = state.model.days;
      });
    };

    return {
      state,
      props,
      formDom,
      tabDom,
      hc_map,
      gys_map,
      onAdd,
      onChangeTab,
    };
  },
};
</script>
<style scoped></style>
